/** MIME types supported by pdf-ingest wave attachment indexing (keep in sync with cloud worker). */
const INDEXABLE_MIME_PREFIXES = ["text/"];
const INDEXABLE_MIME_EXACT = new Set([
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/plain",
    "text/markdown",
    "text/csv",
    "application/json",
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/webp",
    "image/tiff",
]);
const INDEXABLE_EXTENSIONS = /\.(pdf|docx?|xlsx?|txt|md|csv|json|jpe?g|png|gif|webp|tiff?)$/i;
export function isIndexableMime(mimeType, fileName) {
    const mime = `${mimeType || ""}`.trim().toLowerCase();
    if (mime) {
        if (INDEXABLE_MIME_EXACT.has(mime))
            return true;
        if (INDEXABLE_MIME_PREFIXES.some((p) => mime.startsWith(p)))
            return true;
        if (mime.startsWith("image/"))
            return true;
    }
    const name = `${fileName || ""}`.trim().toLowerCase();
    return INDEXABLE_EXTENSIONS.test(name);
}
